import { useDeviceTypesContext } from 'core/contexts/device-types';

export const useDeviceTypes = () => {
    const { deviceTypes, setDeviceTypes, isLoading } = useDeviceTypesContext();

    return {
        getDeviceTypeDetails: (deviceTypeName: string) => deviceTypes.find((dt) => dt.name === deviceTypeName),
        getDeviceTypeDetailsBySlug: (slug: string) => deviceTypes.find((dt) => dt.slug === slug),
        getDeviceTypeDetailsById: (deviceTypeId: string) => deviceTypes.find((dt) => dt.id === deviceTypeId),
        deviceTypes,
        setDeviceTypes,
        isLoading,
    };
};
